import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2, Mail, ArrowLeft, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = window.location.origin + '/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { toast.error('Informe seu email'); return; }
    setLoading(true);
    try {
      await axios.post(`${API_URL}/auth/forgot-password`, { email: email.trim() });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao enviar email');
    } finally { setLoading(false); }
  };

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <div className="bg-white rounded-2xl shadow-lg border p-8 max-w-md w-full text-center">
          <CheckCircle2 className="w-12 h-12 mx-auto text-emerald-500 mb-4" />
          <h2 className="text-xl font-bold mb-2">Email enviado!</h2>
          <p className="text-muted-foreground mb-4">
            Se o email <strong>{email}</strong> estiver cadastrado, voce recebera um link para redefinir sua senha. Verifique sua caixa de entrada e spam.
          </p>
          <Link to="/login"><Button variant="outline" data-testid="back-login-btn"><ArrowLeft className="w-4 h-4 mr-2" />Voltar ao Login</Button></Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="bg-white rounded-2xl shadow-lg border p-8 max-w-md w-full">
        <div className="text-center mb-6">
          <Mail className="w-10 h-10 mx-auto text-primary mb-3" />
          <h2 className="text-2xl font-heading font-bold">Esqueci minha senha</h2>
          <p className="text-muted-foreground text-sm mt-1">Informe seu email para receber o link de redefinicao</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label>Email</Label>
            <Input type="email" placeholder="seu@email.com" value={email}
              onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full" data-testid="forgot-submit-btn">
            {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Enviando...</> : 'Enviar link de redefinicao'}
          </Button>
        </form>
        <div className="mt-4 text-center">
          <Link to="/login" className="text-sm text-muted-foreground hover:text-primary">
            <ArrowLeft className="w-3 h-3 inline mr-1" />Voltar ao Login
          </Link>
        </div>
      </div>
    </div>
  );
}
